import React from "react";
import "./Banner.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Banner = ({ Banner }) => {
  const navigate = useNavigate();

  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // Change this value for the interval between slides
    dots: true, // Show dots for navigation
  };

  return (
    <div className="">
      <Slider {...sliderSettings}>
        {Banner?.map((item) => (
          <div key={item?._id}>
            <Link onClick={() => navigate(`/category/${item?.link}`)}>
              <img
                style={{
                  width: "100vw",
                  maxHeight: "500px",
                  overflow: "hidden",
                }}
                src={item?.Image}
                alt={`Banner ${item?._id}`}
              />
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Banner;
